<template>
  <div>
    <Alert
      text="PLANO GRATUITO"
      callbackText="ASSINAR"
      :callback="() => $router.push({ path: '/assinatura/planos' })"
      :menuFunction="() => toogleMenu()"
      :saveFunction="() => $refs.crossword.saveCrossWord(passatempo.id, timer)"
      :title="passatempo.titulo"
      :subTitle="passatempo.subtitulo"
      :passatempoId="passatempo.id"
      :points="pts"
      :timer="toMinute(timer)"
      :plan="true"
      :isGame="true"
      :backButton="true"
      :backButtonGame="true"
    />

    <div class="row gameBackground" style="height: 77.5vh">
      <div
        class="col-md d-flex flex-column justify-content-start align-items-center game"
      >
        <div v-if="matrix.length > 0 && heightCell" class="game-and-options">
          <div>
            <Passatempo
              :matrix="matrix"
              :key="passatempo.id"
              :chaves="chaves"
              ref="crossword"
              :heightCell="parseFloat(heightCell)"
              :type="passatempo.estilos_de_passatempos_id"
              :gabarito="gabarito"
              :time="timer"
              :pts="pts"
              :finish="finish"
            />
          </div>
        </div>
      </div>

      <div
        class="col-md-9 p-0 options-game"
        id="options-game"
        style="height: 71vh"
      >
        <!-- Comentarios ativos INICIO-->

        <div id="comentarios" class="comentarios">
          <div
            @click="toogleComment"
            class="btn-close-comment d-flex justify-content-center align-items-center"
          >
            VOLTAR A JOGAR
            <i class="fa fa-caret-down ml-3"></i>
          </div>

          <div
            v-if="comentarios.length > 0"
            @scroll="(e) => pagination(e)"
            class="lista-comentarios"
          >
            <template v-for="comentario in comentarios">
              <div
                :key="comentario.id"
                class="card-comentario animate__bounceIn"
              >
                <div
                  class="user-foto"
                  @click="
                    $router.push({ path: `/perfil/${comentario.autor.id}` })
                  "
                  :style="`background-image: url('${
                    comentario.autor.foto
                      ? comentario.autor.foto
                      : 'https://www.ecoscorefloor.burkeind.com/images/663.jpg'
                  }')`"
                ></div>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="name"
                    >{{ comentario.autor.name }}
                    {{ comentario.autor.sobrenome }}</span
                  >

                  <div style="font-size: 12px">
                    <i class="fa fa-clock-o mr-2"></i>
                    <span class="message">{{ comentario.tempo_passado }}</span>
                  </div>
                </div>
                <p class="message">{{ comentario.comentario }}</p>
                <hr />
                <span class="likes">
                  {{
                    comentario.created_at.split(" ")[0].split("-")[2] +
                    "/" +
                    comentario.created_at.split(" ")[0].split("-")[1] +
                    "/" +
                    comentario.created_at.split(" ")[0].split("-")[0]
                  }}</span
                >
              </div>
            </template>
          </div>
          <div class="m-3" v-else>
            <span class="card animate__bounceIn p-3 mt-5"
              >Seja o primeiro a comentar.</span
            >
          </div>
          <div class="input-comentarios">
            <div class="input-label">
              <label class="pl-3">COMENTARIO</label>
              <textarea
                v-model="temp_comentario"
                placeholder="Insira um comentario aqui"
                @click="pause = true"
              >
              </textarea>
            </div>
            <button @click="comentar" class="btn-comentar py-3">
              COMENTAR
            </button>
          </div>
        </div>

        <div
          class="options-game-content d-flex flex-row justify-content-center"
        >
          <button
            class="options-game-button-background"
            @click="
              $store.commit('setStateModal', {
                visible: true,
                title: 'ATENÇÃO',
                type: 'warning',
                message: 'Deseja encerrar o jogo?',
                callbackOk: () =>
                  $refs.crossword.finishCrossWord(passatempo.id, timer, pts),
              })
            "
          >
            VERIFICAR ACERTOS
          </button>

          <button
            class="options-game-button-background"
            @click="$refs.crossword.revealCrossWord()"
          >
            REVELAR RESPOSTAS
          </button>

          <button @click="$refs.crossword.revealLetter()">REVELAR LETRA</button>

          <button @click="$refs.crossword.revealWord()">REVELAR PALAVRA</button>

          <button @click="$refs.crossword.clearCrossWord()">LIMPAR JOGO</button>

          <button @click="$refs.crossword.pauseCrossWord()">
            {{ pause ? "CONTINUAR" : "PAUSAR" }} PASSATEMPO
          </button>

          <button @click="$refs.crossword.saveCrossWord(passatempo.id, timer)">
            SALVAR JOGO
          </button>

          <button @click="$refs.crossword.initCrossWord()">
            RECOMEÇAR JOGO
          </button>

          <!-- <button @click="$refs.crossword.clearWord()">LIMPAR PALAVRA</button> -->
          <button @click="share">COMPARTILHAR JOGO</button>

          <button
            @click="
              $router.push({
                path: `/ranking/edicao/${passatempo.edicoes_id}/passatempo/${passatempo.id}`,
              })
            "
          >
            VER O RANKING
          </button>
        </div>

        <div
          @click="
            () => {
              toogleComment();
              getComments(next_page_url);
            }
          "
          class="btn-show-comment d-flex justify-content-center align-items-center"
        >
          VER COMENTÁRIOS
          <i class="fa fa-caret-down ml-3"></i>
        </div>
      </div>
    </div>

    <div class="row footerDicas">
      <div class="dicas">
        <div class="title d-flex justify-content-center align-items-center">
          <!-- DICAS -->
        </div>
        <div v-if="$refs.crossword" class="dicaContent">
          <i
            @click="$refs.crossword.changeTip('prev')"
            class="fa fa-caret-left fa-1000x"
          ></i>
          <span class="dica">{{
            $refs.crossword.dica_selecionada
              ? $refs.crossword.dica_selecionada.chave
              : ""
          }}</span>
          <i
            @click="$refs.crossword.changeTip('next')"
            class="fa fa-caret-right"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Passatempo from "../components/Passatempo";
import Alert from "../components/AlertaPlano"
import firebase from 'firebase';

export default {
  name: "Jogo",
  components: {
    Passatempo,
    Alert,
  },
  data: () => ({
    matrix: [],
    chaves: [],
    pts: 0,
    pts_max: 0,
    comentarios: [],
    next_page_url: ``,
    temp_comentario: "",
    pause: false,
    finish: false,
    passatempo: {},
    heightCell: 0,
    gabarito: [],
    timer: 0,
    jogo: true,
    show: false,
  }),
  async created(){
    this.$forceUpdate()
    this.analyticSubmit();
  },
  async mounted() {
    this.$store.commit("jogo", true);
    this.$store.commit("loading", true);

    await this.$axios
      .all([
        await this.$axios.get(`/passatempos/${this.$route.params.id}/matrix`),
        await this.$axios.get(`/passatempos/${this.$route.params.id}`),
        await this.$axios.get(`/passatempos/${this.$route.params.id}/gabarito`),
      ])
      .then(
        this.$axios.spread(async (matrixRes, passatempoRes, gabaritoRes) => {
          this.matrix = matrixRes.data.matrix;
          this.chaves = matrixRes.data.chaves;
          this.passatempo = passatempoRes.data[0];
          this.gabarito = gabaritoRes.data.matrix;
          this.next_page_url = `/comentarios/passatempos/${this.$route.params.id}`;
          let copy = [...matrixRes.data.matrix];
          copy.map((el) =>
            el.map((obj) =>
              (obj.palavra_horizontal > 0 || obj.palavra_vertical > 0) &&
              !obj.casa_morta
                ? (this.pts_max += 1)
                : ""
            )
          );
          if (matrixRes.data.acertos != undefined) {
            this.finish = true;
            this.pts = matrixRes.data.acertos;
          }
          if (matrixRes.data.time != undefined) {
            this.timer = parseInt(matrixRes.data.time);
          }
          //console.log("tag", this.$route.query.comentarios);
          if (this.$route.query.comentarios != undefined) {
            this.toogleMenu();
            this.toogleComment();
          }
        })
      );

    if (
      this.passatempo.altura > this.passatempo.largura - 3 ||
      this.passatempo.altura == this.passatempo.largura
    ) {
      this.heightCell =
        (await (document.getElementsByClassName("game")[0].clientHeight -
          document.getElementsByClassName("alert-free-game")[0].clientHeight)) /
        this.matrix.length;
    } else {
      this.heightCell =
        (await document.getElementsByClassName("game")[0].clientWidth) /
        this.matrix[0].length;
    }
    await setInterval(async () => {
      if (!this.pause) {
        this.timer = parseInt(this.timer) + 1;
      }
    }, 1000);

    this.$store.commit("loading", false);
  },
  methods: {
    getElementSize: function (element) {
      return element.clientHeight;
    },
    share() {
      this.$store.commit(
        "setShareLink",
        `https://jogos.recreativa.com.br/jogo/${this.passatempo.id}`
      );
      this.$router.push({ path: "/compartilhar" });
    },
    getComments: function (url) {
      if (url != null) {
        this.$axios
          .get(url)
          .then((res) => res.data)
          .then((res) => {
            let comentarios = [...res.data];
            comentarios = comentarios.sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
            this.comentarios.push(...comentarios);
            this.next_page_url = res.next_page_url;
          });
      }
    },
    toMinute: function (seconds) {
      if (!seconds) return "";
      let d = Number(seconds);
      let m = Math.floor((d % 3600) / 60);
      let s = Math.floor((d % 3600) % 60);
      return `${m < 10 ? "0" + m : m}:${s < 10 ? "0" + s : s}`;
    },
    toogleMenu: function () {
      const el = document.getElementById("options-game");
      if (el.classList.contains("options-game-active")) {
        el.classList.remove("options-game-active");
        this.pause = false;
      } else {
        el.classList.add("options-game-active");
        this.pause = true;
      }
    },
    toogleComment: function () {
      const el = document.getElementById("comentarios");
      if (el.classList.contains("comentarios-active")) {
        el.classList.remove("comentarios-active");
        this.pause = false;
      } else {
        el.classList.add("comentarios-active");
        this.pause = true;
      }
    },
    comentar: function () {
      if (localStorage.getItem("t")) {
        this.$axios
          .post(`comentarios`, {
            destino_passatempos_id: this.$route.params.id,
            comentario: this.temp_comentario,
          })
          .then((res) => res.data)
          .then((res) => {
            this.comentarios.unshift(res);
            this.temp_comentario = "";
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$store.commit("setStateModal", {
          visible: true,
          title: "ATENÇÃO",
          type: "warning",
          message: "Faça login para comentar!",
        });
        this.$router.push({ path: "/login" });
      }
    },
    pagination: function (e) {
      if (e.target.scrollTop + e.target.clientHeight == e.target.scrollHeight) {
        this.getComments(this.next_page_url);
      }
    },
    analyticSubmit: function(){
      try {
        //firebase.analytics().setCurrentScreen("WEB_Jogo");
        firebase.analytics().logEvent("WEB_tela_jogo", {
          titulo: this.passatempo.titulo,
          id: this.passatempo.id,
        });
      } catch (error) {
        console.log("analytic jogo error:", error)
      }
      try {
        this.$intercom.trackEvent("WEB_tela_jogo");
      } catch (error) {
        console.log("analyticIntercom jogo error:", error)
      }
    }
  },
};
</script>
<style scoped>
.gameBackground {
  background: url(../assets/images/fundoGame.jpg);

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.gameBackground::before {
  background-color: rgba(247, 247, 247, 0.541);
  content: "";
  display: block;
  position: absolute;
  width: 72vw;
  height: 72vh;
}
.game-and-options {
  padding: 17px;
}

.btn-change-tip {
  background-color: red;
  height: 100%;
}

.options-game-content {
  flex-wrap: wrap;
  padding-top: 5px;
  background-color: rgb(22, 22, 22);
  overflow-y: auto;
  height: 100%;
  transition: ease 1s;
  align-items: flex-start;
  justify-content: center;
}
.options-game-content button {
  width: 95%;
  height: 30px;
  letter-spacing: 2px;
  font-size: 13px;
  border: none;
  background-color: rgb(22, 22, 22);
  padding: 10px;
  font-weight: bold;
  color: white;
  text-align: start;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.options-game-content button:last-child {
  margin-bottom: 5vh;
}
.options-game-content button:hover {
  background-color: rgb(255, 255, 255);
  color: #1a1a1a;
}
.options-game-button-background {
  background-color: #1a1a1a;
  height: 50%;
}
.options-game {
  flex-wrap: wrap;
  padding-top: 5px;
  background-color: white;
  overflow-y: hidden;
  height: 0vh !important;
  width: 20vw;
  z-index: 999;
  position: absolute;
  right: 14vw;
  display: none;
}
.divisor {
  height: 3px;
  background-color: #eaeaea;
  border-width: 0;
  border: none;
  margin: 0.1rem 0;
  padding: 0;
  width: 95%;
  float: right;
}
.comentarios {
  height: 0vh !important;
  width: 100%;
  background-color: rgb(231, 229, 229);
  z-index: 999;
  position: absolute;
  display: none;
}

.card-comentario {
  padding: 10px 0px 10px 65px;
  width: 90%;
  box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.2);
  margin: 5px 0px;
  background-color: white;
  position: relative;
}

.card-comentario .name {
  text-transform: capitalize;
  font-size: 1.1em;
  letter-spacing: 1px;
}

.card-comentario .likes {
  text-transform: capitalize;
  letter-spacing: 1px;
  font-size: 0.7em;
  font-family: "Agency FB Regular";
}

.card-comentario .message {
  font-size: 0.8em;
  margin-top: 10px;
  opacity: 0.8;
  letter-spacing: 1px;
  font-family: "Agency FB Regular";
  word-break: break-word;
  padding-right: 10px;
}

.card-comentario .user-foto {
  width: 50px;
  height: 50px;
  background-size: cover;
  position: absolute;
  left: 0;
  cursor: pointer;
  top: 0;
}

.comentarios-active {
  height: 68vh !important;
  transition: ease 1s;
  display: block;
}
.options-game-active {
  height: 68vh !important;
  transition: ease-in 1s;
  display: block;
}

.lista-comentarios {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 50px;
  padding-bottom: 200px;
  overflow-y: auto;
  position: relative !important;
}

.lista-comentarios::-webkit-scrollbar {
  display: none;
}

.btn-show-comment {
  background-color: #8d4d9a;
  color: white;
  position: absolute;
  width: 100%;
  height: 5vh;
  letter-spacing: 2px;
  bottom: 0;
}

.btn-close-comment {
  background-color: #8d4d9a;
  color: white;
  position: absolute;
  width: 100%;
  z-index: 9999;
  height: 40px;
  letter-spacing: 2px;
  top: 0;
}

.header {
  width: 50%;
  background-color: #1a1a1a;
  color: white;
  padding: 0px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}
/* .topMenu {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #1a1a1a;
  height: 6.2vh;
} */
.line {
  width: 50%;
  height: 0.5vh;
  background-color: white !important;
  color: white;
}

.infos {
  background-color: #1a1a1a;
  width: 100%;
  color: white;
  padding: 0px 0px;
  font-size: 1.1em;
  display: flex;
  height: 8.5vh;
}
.titleContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
/* .title {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: 400;
}

.sub-title {
  font-size: 15px;
  font-family: "Agency FB Regular";
} */
.iconsContent {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icons {
  width: 25%;
}

.menuPop {
  width: 100%;
  color: white;
  font-size: 1.1em;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 15px;
}

.infos span {
  text-transform: uppercase;
}

.dica::-webkit-scrollbar {
  display: none;
}
.footerDicas {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 20vh;
  width: 100%;
}
.dica {
  height: 15vh;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35%;
  text-align: justify;
  user-select: none;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 19px;
  overflow: auto;
}
.dicas {
  width: 100%;
  height: 18vh;
  background-color: white;
  color: black;
  position: absolute;
  bottom: 0px;
  padding-bottom: 0px;
  font-size: 35px;
}

.dicas i {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.dicaContent {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 18vh;
}

.input-comentarios {
  position: absolute;
  bottom: 0vh;
  width: 100%;
  display: flex;
  background-color: white;
  padding-top: 10px;
  flex-direction: column;
  box-shadow: -1px 0px 20px rgba(0, 0, 0, 0.233);
}

.input-comentarios button {
  margin: 0;
  background-color: #1a1a1a;
  border: 0;
  color: white;
  width: 100%;
}

.input-comentarios .input-label {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.input-comentarios .input-label textarea {
  height: 70px;
  border: none;
  outline: 0;
  padding-left: 15px;
  font-family: "Agency FB Regular";
}

.dicas .title {
  background-color: #8d4d9a;
  width: 100%;
  height: 10px;
  color: white;
}
</style>